module.exports = __webpack_public_path__ + "static/media/UploadExcel.740e2233.svg";